import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useHttpClient } from "@/core/http/HttpClientContext";
import { TaskStatus, taskKeys } from "@/domains/Tasks/types";
import { portalTasksService } from "../services/portalTasksService";

/** The portal Tasks list by status. A tab switch keeps the previous list
 * as placeholder data, so only the first load shows the spinner (DD-001). */
export function usePortalTasksQuery(clientId: string, status: TaskStatus) {
  const http = useHttpClient();
  return useQuery({
    queryKey: taskKeys.portal(clientId, status),
    queryFn: () => portalTasksService.list(http, status),
    placeholderData: keepPreviousData,
  });
}
